export function formatCountdown(time: number): 'nu' | number {
  const difference = time - Date.now();
  const minutesToDeparture = Math.round(difference / 1000 / 60);
  return minutesToDeparture <= 0 ? 'nu' : minutesToDeparture;
}
